import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

export default function RedirectIfTerminalAuthenticated({ children }) {
  const auth = localStorage.getItem("terminalUserAuth");

  if (auth) {
    return <Navigate to="/terminal/dashboard" replace />;
  }

  return children;
}

RedirectIfTerminalAuthenticated.propTypes = {
  children: PropTypes.node.isRequired,
};
